import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { ContactMeDataModel } from '../../../features/digital-catalogue/digital-catalogue.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
declare var bootstrap: any;

@Component({
  selector: 'app-interest-share-popup',
  imports: [CommonModule, FormsModule],
  templateUrl: './interest-share-popup.component.html',
  styleUrls: ['./interest-share-popup.component.scss']
})
export class InterestSharePopupComponent {

  constructor() { }

  /** ViewChild reference to the modal HTML element */
  @ViewChild('interestSharedPopup') interestSharedPopup!: ElementRef;
  contactData!: ContactMeDataModel;
  private modalInstance: any; // keep a single reference
  doNotShowAgain = false;

  @Output() confirmClicked = new EventEmitter<void>();
  @Output() doNotShowAgainChange = new EventEmitter<boolean>(); // for checkbox state
  @Output() cancelClicked = new EventEmitter<void>();

  /**
   * Displays the Bootstrap modal by initializing and showing it.
   */
  show(data: ContactMeDataModel): void {
    this.contactData = data;
    // initialize modal only once
    if (!this.modalInstance) {
      this.modalInstance = new bootstrap.Modal(this.interestSharedPopup.nativeElement);
    }

    this.modalInstance.show();
  }

  hide(): void {
    if (this.modalInstance) {
      this.modalInstance.hide(); // correctly hides the same instance
    }
  }

  onConfirm() {
    // Handle confirm action
    this.confirmClicked.emit();
  }

  onCheckboxChange(event: any) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.doNotShowAgainChange.emit(isChecked);
  }

  onCancel() {
    this.cancelClicked.emit();
  }


  resetDoNotShowCheckbox() {
    this.doNotShowAgain = false;
  }

}
